import React, { useRef, useState, useEffect } from "react";
import { V_URL_API } from "../../../../../../utils/config";
import { useWebSocket } from "../../../../../../context/WebSocketContext";
import { ThreeCircles } from "react-loader-spinner"; // Importa el componente del spinner
import { useGlobalContext } from "../../../../../../context/GlobalContext";
import AlertaEntity from "../../../../../../core/entities/alertaEntity";
import { useNavigate } from "react-router-dom";
import Subtitulos from "./components/Subtitulos";
import TooltipText from "../../../../../../components/TooltipText/TooltipText";

export default function VideoPlayer({
  vLeccionId = null,
  vLeccion = null,
  actualizarLeccion = () => {},
}) {
  const { mensajeWs, enviarMensaje, vIsActivo } = useWebSocket(); // Usa el WebSocket
  const { vAlertaRef } = useGlobalContext(); // Usa el WebSocket
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [playbackError, setPlaybackError] = useState(false); // Nuevo estado para errores
  const [vIsHover, setVIsHover] = useState(false);
  const [vIsHoverAddSubtract10, setvIsHoverAddSubtract10] = useState(false);
  const [bufferedPercentage, setBufferedPercentage] = useState(0); // Nuevo estado para el progreso de carga
  const [volume, setVolume] = useState(1); // Estado para el volumen inicial
  const [dragPercentage, setDragPercentage] = useState(null); // New state for drag percentage
  const [isDragging, setIsDragging] = useState(false); // Track dragging state
  const [isVolumeDragging, setIsVolumeDragging] = useState(false); // Track volume dragging state

  const [vIsVideoTerminado, setVIsVideoTerminado] = useState(false);

  const [vIsPrimerPlay, setVIsPrimerPlay] = useState(true);
  const debounceTimeoutRef = useRef(null);
  const [isVolumeHover, setIsVolumeHover] = useState(false); // Nuevo estado para hover
  const barraRef = useRef(null); // Referencia para la barra de volumen
  const timerRef = useRef(null); // Referencia para el temporizador
  const cursoCompradoVideoRef = useRef(null); // Reference for the div
  const [isFullscreen, setIsFullscreen] = useState(false); // Track fullscreen state

  const [vIsSubtitulos, setVIsSubtitulos] = useState(false); // Track fullscreen state

  const navigate = useNavigate();

  const toggleFullscreen = () => {
    const element = cursoCompradoVideoRef.current;
    if (!element) return;

    if (!document.fullscreenElement) {
      element
        .requestFullscreen()
        .then(() => setIsFullscreen(true)) // Set fullscreen state to true
        .catch((err) => {
          console.error(
            `Error attempting to enable fullscreen mode: ${err.message}`
          );
        });
    } else {
      document
        .exitFullscreen()
        .then(() => setIsFullscreen(false)) // Set fullscreen state to false
        .catch((err) => {
          console.error(
            `Error attempting to exit fullscreen mode: ${err.message}`
          );
        });
    }
  };

  /*
  const [subtituloUrl, setSubtituloUrl] = useState(null);

  useEffect(() => {
    console.log(vLeccion);
    // Cargar subtítulo desde FastAPI
    const cargarSubtitulos = async () => {
      try {
        const res = await fetch(
          `${V_URL_API}/api/subtitulos/vtt/${vLeccion.leccion_subtitulos}`
        );
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        setSubtituloUrl(url);
      } catch (err) {
        console.error("Error cargando subtítulos:", err);
      }
    };

    cargarSubtitulos();

    // Limpia el objeto URL cuando se desmonta el componente
    return () => {
      if (subtituloUrl) {
        URL.revokeObjectURL(subtituloUrl);
      }
    };
  }, [vLeccion]);
  */

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement); // Update state based on fullscreen status
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    if (mensajeWs?.detail?.acción === "CURSO_FINALIZADO") {
      vAlertaRef.current.show(
        new AlertaEntity(
          "Curso finalizado",
          "Has completado todas las lecciones del curso.",
          "verde",
          10
        )
      );
    }
    if (mensajeWs?.detail?.acción === "HABILITAR_SIGUIENTE_LECCION") {
      actualizarLeccion();
      navigate(
        `?f=cc&curso_id=${vLeccion.curso_seleccionado_id}&leccion_id=${vLeccion.siguiente_leccion_id}`
      );
      window.location.reload();
      vAlertaRef.current.show(
        new AlertaEntity(
          "Lección completada",
          "Puedes continuar con la siguiente lección.",
          "verde",
          10
        )
      );
    }
  }, [mensajeWs]);

  // Lifecycle methods
  useEffect(() => {
    let interval = null;

    if (isPlaying) {
      interval = setInterval(mEnviarProgresoVideo, 10000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isPlaying]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.addEventListener("progress", handleProgress);
      return () => {
        video.removeEventListener("progress", handleProgress);
      };
    }
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.load(); // Forzar la descarga del video en segundo plano
    }
  }, [vLeccionId]);

  useEffect(() => {
    const video = videoRef.current;

    const handleVideoError = () => {
      if (video && video.error) {
        console.error("Error en el video:", video.error);
        switch (video.error.code) {
          case 1:
            console.error(
              "MEDIA_ERR_ABORTED: La reproducción fue cancelada por el usuario."
            );
            break;
          case 2:
            console.error(
              "MEDIA_ERR_NETWORK: Un error de red ocurrió durante la descarga."
            );
            break;
          case 3:
            console.error(
              "MEDIA_ERR_DECODE: Un error ocurrió mientras se decodificaba el video."
            );
            break;
          case 4:
            console.error(
              "MEDIA_ERR_SRC_NOT_SUPPORTED: El formato del video no es soportado."
            );
            break;
          default:
            console.error("Error desconocido en el video.");
        }
      }
    };

    if (video) {
      video.addEventListener("error", handleVideoError);
      return () => {
        video.removeEventListener("error", handleVideoError);
      };
    }
  }, []);

  // Event handlers
  const handlePlayPause = () => {
    if (vIsHoverAddSubtract10) return;
    const video = videoRef.current;
    if (!videoRef.current) {
      //alert("handlePlayPause if 2");
      console.error("Referencia al video no disponible.");
      setPlaybackError(true);
      return;
    }

    if (video.readyState === 0) {
      console.warn("readyState es 0, forzando carga del video...");
      video.load();
      // Intenta reproducir luego de un pequeño delay
      setTimeout(() => {
        video.play()
          .then(() => {
            console.log("Reproducción iniciada tras forzar carga.");
            setPlaybackError(false);
            setIsPlaying(true);
          })
          .catch((error) => {
            console.error("Error tras intentar reproducir:", error);
            setPlaybackError(true);
          });
      }, 500);  // Dale un pequeño tiempo a WebKit
      return;
    }

    if (videoRef.current.readyState < 2) {
      //alert(
      //  `${videoRef.current.readyState}`
      //);
      
      console.error(
        `El video no está listo para reproducirse. Estado actual: ${videoRef.current.readyState}`
      );
      setPlaybackError(true);
      return;
    }

    if (videoRef.current.ended) {
      videoRef.current.currentTime = 0; // Reinicia el video si terminó
    }

    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false); // Actualiza el estado después de pausar

      // Inicia un temporizador de 10 segundos para actualizar vIsPrimerPlay
      timerRef.current = setTimeout(() => {
        setVIsPrimerPlay(true);
      }, 3000);
    } else {
      // Cancela el temporizador si se pone play
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }

      setVIsPrimerPlay(false);
      videoRef.current
        .play()
        .then(() => {
          console.log("El video comenzó a reproducirse correctamente.");
          setPlaybackError(false); // Reinicia el estado de error si play() tiene éxito
          setIsPlaying(true); // Actualiza el estado después de reproducir
        })
        .catch((error) => {
          console.error("Error al intentar reproducir el video:", error);
          setPlaybackError(true); // Manejar error si play() falla
          // Reintento automático después de 1 segundo
          setTimeout(() => {
            videoRef.current
              .play()
              .then(() => {
                console.log("Reintento exitoso al reproducir el video.");
                setPlaybackError(false);
                setIsPlaying(true); // Actualiza el estado si el reintento tiene éxito
              })
              .catch((retryError) => {
                console.error(
                  "Reintento fallido al reproducir el video:",
                  retryError
                );
                setPlaybackError(true); // Mantener el estado de error si el reintento falla
              });
          }, 1000);
        });
    }
  };

  const handleTimeUpdate = () => {
    setCurrentTime(videoRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(videoRef.current.duration);
    setIsLoading(false);
  };

  const handleLoading = () => {
    setIsLoading(true);
  };

  const handlePlaybackError = () => {
    console.error(
      "Error de reproducción detectado. Verifica si el archivo de video está disponible o si hay restricciones del navegador."
    );
    console.error(`URL del video: ${videoRef.current?.src}`);
    setPlaybackError(true); // Actualizar estado en caso de error
    setIsLoading(false);
  };

  const handleCanPlay = () => {
    console.log("play");
    setIsLoading(false);
    setPlaybackError(false); // Reiniciar error si el video puede reproducirse
  };

  const handleProgress = () => {
    if (videoRef.current) {
      const buffered = videoRef.current.buffered;
      const currentTime = videoRef.current.currentTime;
      if (buffered.length > 0) {
        const bufferedEnd = buffered.end(buffered.length - 1);
        const duration = videoRef.current.duration;
        if (duration > 0) {
          setBufferedPercentage((bufferedEnd / duration) * 100); // Calcula el porcentaje de carga
        }
      }
    }
  };

  const mNewTimeVideo = (newTime) => {
    videoRef.current.currentTime = newTime; // Cambia el tiempo actual del video
    setCurrentTime(newTime); // Actualiza el estado del tiempo actual

    setTimeout(() => {
      mEnviarProgresoVideo(); // Envía el progreso después de buscar
    }, 250);
    // Forzar la reproducción desde el nuevo tiempo si está en pausa
    if (!isPlaying) {
      videoRef.current
        .play()
        .then(() => {
          console.log("El video comenzó a reproducirse después de buscar.");
          setPlaybackError(false);
          setIsPlaying(true);
        })
        .catch((error) => {
          console.error(
            "Error al intentar reproducir el video después de buscar:",
            error
          );
          setPlaybackError(true);
        });
    }
  };

  const mAdd10Sec = () => {
    const newTime = videoRef.current.currentTime + 10; // Calcula el nuevo tiempo
    if (newTime >= duration) {
      videoRef.current.currentTime = duration; // Establece el tiempo al límite máximo
      setCurrentTime(duration); // Actualiza el estado al límite máximo
    } else {
      videoRef.current.currentTime = newTime; // Cambia el tiempo actual del video
      setCurrentTime(newTime); // Actualiza el estado del tiempo actual
    }

    setTimeout(() => {
      mEnviarProgresoVideo(); // Envía el progreso después de buscar
    }, 250);
  };

  const mSubtract10Sec = () => {
    const newTime = videoRef.current.currentTime - 10; // Calcula el nuevo tiempo
    if (newTime <= 0) {
      videoRef.current.currentTime = 0; // Establece el tiempo al mínimo (0)
      setCurrentTime(0); // Actualiza el estado al mínimo
    } else {
      videoRef.current.currentTime = newTime; // Cambia el tiempo actual del video
      setCurrentTime(newTime); // Actualiza el estado del tiempo actual
    }

    setTimeout(() => {
      mEnviarProgresoVideo(); // Envía el progreso después de buscar
    }, 250);
  };

  const handleSeekBarClick = (event) => {
    if (!videoRef.current || duration === 0) return;

    const rect = event.currentTarget.getBoundingClientRect(); // Obtiene las dimensiones del contenedor
    const clickX = event.clientX - rect.left; // Calcula la posición del clic relativa al contenedor
    const percentage = clickX / rect.width; // Calcula el porcentaje del clic en la barra
    const newTime = percentage * duration; // Calcula el tiempo correspondiente en el video

    // Avanza el video al nuevo tiempo sin reiniciar la carga
    mNewTimeVideo(newTime);
  };

  const handleSeekBarMove = (event) => {
    const seekBar = document.querySelector(".barra-reproduccion-duracion");
    if (!seekBar || !isFinite(duration) || duration === 0) return;

    const rect = seekBar.getBoundingClientRect();
    const dragX = Math.min(Math.max(event.clientX - rect.left, 0), rect.width); // Ensure drag stays within bounds
    const percentage = (dragX / rect.width) * 100;

    setDragPercentage(percentage); // Update drag percentage
  };

  const handleMouseDown = (event) => {
    setIsDragging(true); // Start dragging
    handleSeekBarMove(event); // Update position immediately on mouse down
  };

  const handleMouseMove = (event) => {
    console.log("first");
    if (!isDragging) return; // Only handle movement if dragging
    handleSeekBarMove(event);
  };

  const handleMouseUp = () => {
    if (!isDragging) return;
    setIsDragging(false); // Stop dragging
    setDragPercentage(null); // Reset drag percentage

    const seekBar = document.querySelector(".barra-reproduccion-duracion");
    if (!seekBar || !isFinite(duration) || duration === 0) return;

    const rect = seekBar.getBoundingClientRect();
    const clickX = rect.width * (dragPercentage / 100); // Calculate the position based on dragPercentage
    const percentage = clickX / rect.width; // Calculate the percentage of the click on the bar
    const newTime = percentage * duration; // Calculate the corresponding time in the video

    mNewTimeVideo(newTime);
  };

  const handleSeekBarDragStart = () => {
    setDragPercentage(calculatePercentage(currentTime, duration)); // Initialize drag percentage
  };

  const handleSeekBarDragEnd = (event) => {
    setDragPercentage(null); // Reset drag percentage
    const seekBar = document.querySelector(".barra-reproduccion-duracion");
    if (!seekBar || !isFinite(duration) || duration === 0) return;

    const rect = seekBar.getBoundingClientRect();
    if (rect.width === 0) {
      console.error("Barra de reproducción tiene un ancho de 0.");
      return;
    }

    const dragX = Math.min(Math.max(event.clientX - rect.left, 0), rect.width); // Ensure drag stays within bounds
    const percentage = dragX / rect.width;
    const newTime = percentage * duration; // Calcula el tiempo correspondiente en el video

    // Avanza el video al nuevo tiempo sin reiniciar la carga
    mNewTimeVideo(newTime);
  };

  const handleMouseLeave = () => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      if (isPlaying) {
        mEnviarProgresoVideo();
      }
    }, 800); // Espera de 800ms antes de ejecutar (puedes ajustar)
  };

  const handleMouseMovePantalla = () => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    setVIsHover(true); // Activate hover on movement
    cursoCompradoVideoRef.current.style.cursor = "default"; // Show the mouse cursor

    if (!isPlaying) {
      // Inicia un temporizador de 10 segundos para actualizar vIsPrimerPlay
      timerRef.current = setTimeout(() => {
        setVIsPrimerPlay(true);
      }, 3000);
    }

    // Reset the timeout to hide the mouse and deactivate hover if no movement occurs
    debounceTimeoutRef.current = setTimeout(() => {
      setVIsHover(false); // Deactivate hover
      cursoCompradoVideoRef.current.style.cursor = "none"; // Hide the mouse cursor
    }, 3000); // Adjust timeout duration as needed
  };

  const handleMouseEnter = () => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    setVIsHover(true);
  };

  const handleVolumeMouseDown = (event) => {
    setIsVolumeDragging(true); // Start dragging
    handleVolumeMove(event); // Update position immediately on mouse down
  };

  const handleVolumeMouseMove = (event) => {
    if (!isVolumeDragging) return; // Only handle movement if dragging
    handleVolumeMove(event);
  };

  const handleVolumeMouseUp = () => {
    if (!isVolumeDragging) return;
    setIsVolumeDragging(false); // Stop dragging
  };

  const handleVolumeMove = (event) => {
    if (!barraRef.current) return;

    const rect = barraRef.current.getBoundingClientRect();
    const dragX = Math.min(Math.max(event.clientX - rect.left, 0), rect.width); // Ensure drag stays within bounds
    const percentage = Math.min(Math.max(dragX / rect.width, 0), 1); // Ensure percentage is between 0 and 1

    videoRef.current.volume = percentage; // Adjust the video volume
    setVolume(percentage); // Update the volume state
  };

  const setResumeTime = () => {
    console.log("Video cargado");
    handleLoading();

    // Establece el tiempo actual del video a segundos_reanudacion si está disponible
    if (vLeccion?.segundos_reanudacion) {
      // Avanza el video al nuevo tiempo sin reiniciar la carga
      videoRef.current.currentTime = vLeccion.segundos_reanudacion; // Cambia el tiempo actual del video
      setCurrentTime(vLeccion.segundos_reanudacion); // Actualiza el estado del tiempo actual
    }
  };

  // Utility methods
  const calculatePercentage = (currentTime, duration) => {
    if (duration === 0) return 0; // Evitar división por cero
    return (currentTime / duration) * 100;
  };

  const mEnviarProgresoVideo = (vTerminado = null) => {
    if (vIsActivo) {
      enviarMensaje({
        data: {
          leccion_id: vLeccionId,
          siguiente_leccion_id: vLeccion?.siguiente_leccion_id,
          progreso:
            vTerminado != null
              ? videoRef.current.duration
              : videoRef.current.currentTime,
          duracion_video: videoRef.current.duration, // Renombrado de total_tiempo_video a duracion_video
          terminado: vTerminado != null ? vTerminado : vIsVideoTerminado,
          leccion_actual_numero: vLeccion?.leccion_actual_numero,
        },
        accion: "ACTUALIZAR_PROGRESO_VIDEO",
      });
    }
  };

  // Rendering methods
  /**
   * Renderiza los controles personalizados del reproductor de video.
   *
   * @returns {JSX.Element|null} Los controles del reproductor de video, o null si es la primera reproducción.
   *
   * @description
   * Esta función genera un conjunto de controles para el reproductor de video, incluyendo
   * reproducción/pausa, volumen, visualización de tiempo, alternar pantalla completa y
   * una barra de progreso con funcionalidad de arrastre. Los controles se muestran
   * condicionalmente según el estado de hover y otros estados de reproducción.
   *
   * @component
   *
   * @example
   * // Ejemplo de uso dentro de un componente de reproductor de video
   * const controles = mControls();
   *
   * @dependencies
   * - `calculatePercentage`: Una función de utilidad para calcular valores porcentuales.
   * - `handlePlayPause`: Función para alternar el estado de reproducción/pausa.
   * - `mVolumen`: Función para renderizar el control de volumen.
   * - `toggleFullscreen`: Función para alternar el modo de pantalla completa.
   * - `handleSeekBarClick`: Función para manejar clics en la barra de progreso.
   * - `handleMouseDown`: Función para manejar eventos de arrastre en la barra de progreso.
   *
   * @state
   * - `vIsPrimerPlay` (boolean): Indica si es la primera reproducción.
   * - `vIsHover` (boolean): Indica si los controles están siendo hovered.
   * - `isPlaying` (boolean): Indica si el video se está reproduciendo actualmente.
   * - `isFullscreen` (boolean): Indica si el video está en modo de pantalla completa.
   * - `currentTime` (number): El tiempo actual de reproducción del video en segundos.
   * - `duration` (number): La duración total del video en segundos.
   * - `bufferedPercentage` (number): El porcentaje del video que ha sido cargado.
   * - `dragPercentage` (number|null): El porcentaje de la barra de progreso que se está arrastrando.
   * - `isDragging` (boolean): Indica si la barra de progreso está siendo arrastrada.
   */
  const mControls = () => {
    if (vIsPrimerPlay) return null;
    const percentage = calculatePercentage(currentTime, duration);
    return (
      <div
        className="box-curso-comprado-video-controlador"
        style={{ opacity: vIsHover ? 1 : 0 }}
      >
        <div className="box-playpause-accion" onClick={handlePlayPause}>
          <div class="frame-290253">
            <div
              className="box-regresar-adelantar"
              onMouseEnter={() => setvIsHoverAddSubtract10(true)}
              onMouseLeave={() => {
                setvIsHoverAddSubtract10(false);
              }}
              onClick={mSubtract10Sec}
            >
              <img
                className="botones-regresa-adelantar"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTIgNTgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxnIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+PHBhdGggZD0iTTI4LjI4MyA2LjEwNiAzMS4zIDMuNTE5QTIgMiAwIDAgMCAyOC43LjQ4MWwtNyA2YTIgMiAwIDAgMCAwIDMuMDM4bDcgNmEyIDIgMCAxIDAgMi42LTMuMDM4bC0yLjcxMS0yLjMyM2MxMS43MzIgMS4zOSAyMC4yNzIgMTEuOCAxOS4zNDMgMjMuNTc3cy0xMC45OTUgMjAuNzItMjIuOCAyMC4yNTNDMTMuMzI3IDUzLjUyMiAzLjk5NyA0My44MTQgNCAzMmEyMS43NzEgMjEuNzcxIDAgMCAxIDQuNzMxLTEzLjYzMiAyIDIgMCAxIDAtMy4xMzgtMi40OEEyNS43MzMgMjUuNzMzIDAgMCAwIDAgMzJjLS4wMDMgMTQuMDYzIDExLjE3NyAyNS41OCAyNS4yMzQgMjUuOTk0IDE0LjA1OC40MTQgMjUuODk2LTEwLjQyNCAyNi43MjEtMjQuNDYzLjgyNS0xNC4wNC05LjY2My0yNi4xOS0yMy42NzItMjcuNDI1eiIgZmlsbD0iI2ZmZmZmZiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjxwYXRoIGQ9Ik0xNS43IDE1LjUxOWEyIDIgMCAxIDAgMi42LTMuMDM4TDEzLjA3MyA4IDE4LjMgMy41MTlBMiAyIDAgMCAwIDE1LjcuNDgxbC03IDZhMiAyIDAgMCAwIDAgMy4wMzh6TTE2Ljg5MSAyMS4zMzZsLTMgMkEyIDIgMCAwIDAgMTYgMjYuNzMyVjQwaC0xYTIgMiAwIDEgMCAwIDRoNmEyIDIgMCAxIDAgMC00aC0xVjIzYTIgMiAwIDAgMC0zLjEwOS0xLjY2NHpNMzQgNDRhNSA1IDAgMCAwIDUtNVYyNmE1IDUgMCAwIDAtNS01aC0zYTUgNSAwIDAgMC01IDV2MTNhNSA1IDAgMCAwIDUgNXptLTQtNVYyNmExIDEgMCAwIDEgMS0xaDNhMSAxIDAgMCAxIDEgMXYxM2ExIDEgMCAwIDEtMSAxaC0zYTEgMSAwIDAgMS0xLTF6IiBmaWxsPSIjZmZmZmZmIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iIj48L3BhdGg+PC9nPjwvZz48L3N2Zz4="
              />
            </div>
            <div
              className="box-regresar-adelantar"
              onMouseEnter={() => setvIsHoverAddSubtract10(true)}
              onMouseLeave={() => {
                setvIsHoverAddSubtract10(false);
              }}
              onClick={mAdd10Sec}
            >
              <img
                className="botones-regresa-adelantar"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTIgNTgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxnIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+PHBhdGggZD0iTTQ2LjQwNyAxNS44ODhhMiAyIDAgMCAwLTMuMTM4IDIuNDhBMjEuNzcxIDIxLjc3MSAwIDAgMSA0OCAzMmMuMDAzIDExLjgxNC05LjMyNiAyMS41MjEtMjEuMTMxIDIxLjk4OC0xMS44MDUuNDY2LTIxLjg3MS04LjQ3NC0yMi44LTIwLjI1Mi0uOTMtMTEuNzc3IDcuNjA4LTIyLjE4NyAxOS4zNC0yMy41NzhMMjAuNyAxMi40ODFhMiAyIDAgMCAwIDIuNiAzLjAzOGw3LTZhMiAyIDAgMCAwIDAtMy4wMzhsLTctNmEyIDIgMCAxIDAtMi42IDMuMDM4bDMuMDE5IDIuNTg3QzkuNzA5IDcuMzQtLjc3OSAxOS40OS4wNDUgMzMuNTI5czEyLjY2MiAyNC44OCAyNi43MiAyNC40NjVDNDAuODIzIDU3LjU4MSA1Mi4wMDMgNDYuMDY0IDUyIDMyYTI1LjczMyAyNS43MzMgMCAwIDAtNS41OTMtMTYuMTEyeiIgZmlsbD0iI2ZmZmZmZiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjxwYXRoIGQ9Ik0zMy40ODEgMTUuM2EyIDIgMCAwIDAgMi44MjEuMjE3bDctNmEyIDIgMCAwIDAgMC0zLjAzOGwtNy02YTIgMiAwIDEgMC0yLjYgMy4wMzhMMzguOTI3IDggMzMuNyAxMi40ODFhMiAyIDAgMCAwLS4yMTkgMi44MTl6TTE1IDQwYTIgMiAwIDEgMCAwIDRoNmEyIDIgMCAxIDAgMC00aC0xVjIzYTIgMiAwIDAgMC0zLjEwOS0xLjY2NGwtMyAyQTIgMiAwIDAgMCAxNiAyNi43MzJWNDB6TTMxIDIxYTUgNSAwIDAgMC01IDV2MTNhNSA1IDAgMCAwIDUgNWgzYTUgNSAwIDAgMCA1LTVWMjZhNSA1IDAgMCAwLTUtNXptNCA1djEzYTEgMSAwIDAgMS0xIDFoLTNhMSAxIDAgMCAxLTEtMVYyNmExIDEgMCAwIDEgMS0xaDNhMSAxIDAgMCAxIDEgMXoiIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9nPjwvc3ZnPg=="
              />
            </div>
          </div>
        </div>
        <div className="barra-reproduccion-contendio">
          <div className="barra-reproduccion-info">
            <div className="barra-reproduccion-info-1">
              <TooltipText vText={isPlaying ? "Pausar" : "Reproducir"}>
                <i
                  className={`fi ${
                    isPlaying ? "fi-sr-pause" : "fi-sr-play"
                  } iconos-play-pause`}
                  onClick={handlePlayPause}
                ></i>
              </TooltipText>

              {mVolumen()}
              <div className="barra-reproduccion-tiempo-2">
                {Math.floor(currentTime / 60)}:
                {Math.floor(currentTime % 60)
                  .toString()
                  .padStart(2, "0")}{" "}
                / {Math.floor(duration / 60)}:
                {Math.floor(duration % 60)
                  .toString()
                  .padStart(2, "0")}
              </div>
            </div>
            <div class="contenedor-screen-subtitulos">
              <TooltipText vText="Subtítulos">
                <div
                  class="contenedor-subtitulo"
                  onClick={() => setVIsSubtitulos(!vIsSubtitulos)}
                  style={{
                    borderBottomColor: vIsSubtitulos
                      ? "#FF3A3A"
                      : "transparent",
                  }}
                >
                  <i class="fi fi-sr-subtitles iconos-subtitulo"></i>
                </div>
              </TooltipText>
              <TooltipText vText="Pantalla completa">
                <i
                  className={`fi ${
                    isFullscreen ? "fi-rs-compress" : "fi-rs-expand"
                  } iconos-play-pause`}
                  onClick={toggleFullscreen}
                ></i>
              </TooltipText>
            </div>
          </div>
          <div
            id="barra-reproduccion"
            className="barra-reproduccion-duracion"
            onClick={handleSeekBarClick} // Agrega el manejador de clic
          >
            <div className="barra-reproduccion-2"></div> {/* Barrita blanca */}
            <div
              className="barra-reproduccion-buffered"
              style={{ width: `${bufferedPercentage}%` }} // Aplica el porcentaje de carga
            ></div>
            <div
              className="barra-reproduccion-1-2"
              style={{
                width: `${
                  dragPercentage !== null
                    ? dragPercentage
                    : calculatePercentage(currentTime, duration)
                }%`,
              }}
            ></div>
            <div
              className="barra-reproduccion-circulo"
              style={{
                cursor: isDragging ? "grabbing" : "grab",
                inset: `0% 0% 0% ${
                  dragPercentage !== null
                    ? dragPercentage
                    : calculatePercentage(currentTime, duration)
                }%`,
              }}
              onMouseDown={handleMouseDown}
            ></div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const barraReproduccion = document.getElementById("barra-reproduccion");
    if (!barraReproduccion) return;

    const handleMouseUpLocal = () => handleMouseUp();
    const handleMouseMoveLocal = (event) => handleMouseMove(event);

    // Add local mouse event listeners
    barraReproduccion.addEventListener("mouseup", handleMouseUpLocal);
    barraReproduccion.addEventListener("mousemove", handleMouseMoveLocal);

    return () => {
      // Clean up event listeners
      barraReproduccion.removeEventListener("mouseup", handleMouseUpLocal);
      barraReproduccion.removeEventListener("mousemove", handleMouseMoveLocal);
    };
  }, [isDragging, dragPercentage]);

  useEffect(() => {
    const handleMouseUpGlobal = () => handleVolumeMouseUp();
    const handleMouseMoveGlobal = (event) => handleVolumeMouseMove(event);

    // Add global mouse event listeners
    window.addEventListener("mouseup", handleMouseUpGlobal);
    window.addEventListener("mousemove", handleMouseMoveGlobal);

    return () => {
      // Clean up event listeners
      window.removeEventListener("mouseup", handleMouseUpGlobal);
      window.removeEventListener("mousemove", handleMouseMoveGlobal);
    };
  }, [isVolumeDragging]);

  const mInfoVideo = () => {
    return (
      <div class="box-curso-comprado-video-info">
        <div data-figma-id="1621:15237" class="curso-comprado-video-titulos">
          <p data-figma-id="1621:15238" class="curso-comprado-video-titulo-1">
            Lección {vLeccion?.leccion_actual_numero.split("/")[0]}:
          </p>
          <p data-figma-id="1621:15239" class="curso-comprado-video-titulo-2">
            {vLeccion?.leccion_actual_nombre}
          </p>
        </div>
        <p data-figma-id="1621:15240" class="curso-comprado-video-titulo-3">
          {vLeccion?.curso}
        </p>
      </div>
    );
  };

  const mPlayGrande = () => {
    return (
      <div
        data-figma-id="1621:15241"
        class="icono-play"
        onClick={handlePlayPause}
      >
        <i
          className={`fi ${isPlaying ? "fi-sr-pause" : "fi-sr-play"} tocar-1`}
        ></i>
      </div>
    );
  };

  const mVolumen = () => {
    return (
      <div
        vText="Control de volumen"
        className="box-volumen-controlador"
        onMouseEnter={() => setIsVolumeHover(true)} // Maneja el hover
        onMouseLeave={() => {
          if (!isVolumeDragging) {
            setIsVolumeHover(false); // Set hover to false only if not dragging
          }
        }} // Maneja el hover
      >
        <TooltipText vText="Volumen">
          <i
            className={`fi fi-ss-volume${
              volume === 0 ? "-mute" : ""
            } iconos-play-pause`}
            onClick={() => {
              const newVolume = volume > 0 ? 0 : 1; // Alterna entre silenciar y volumen medio
              videoRef.current.volume = newVolume;
              setVolume(newVolume);
            }}
          ></i>
        </TooltipText>

        <div
          className="control-volumne"
          style={{
            width: isVolumeHover ? "100px" : "0px", // Cambia el tamaño en hover
            transition: "width 0.3s ease", // Transición suave
            overflow: "hidden", // Oculta contenido cuando el tamaño es 0
          }}
          ref={barraRef} // Asigna la referencia
          onClick={(event) => {
            if (barraRef.current) {
              const rect = barraRef.current.getBoundingClientRect();
              handleVolumeMove(event, rect); // Ajusta el volumen relativo a la barra
            }
          }}
        >
          <div className="barra-volumne-blanco"></div>
          <div
            className="barra-volumen-selector-gris"
            style={{
              width: `${volume * 100}%`, // Ajusta el ancho según el volumen actual
            }}
          ></div>
          <div
            className="cirulo-volumen-selector-gris"
            onMouseDown={handleVolumeMouseDown} // Start dragging
            style={{
              inset: `0% 0% 0% ${volume * 100}%`,
              cursor: isVolumeDragging ? "grabbing" : "grab", // Change cursor during drag
            }}
          ></div>
          <div className="box-barra-volumen-selector"></div>
        </div>
      </div>
    );
  };

  // Main render
  if (!vLeccionId) {
    return (
      <div className="curso-comprado-video">No hay lección seleccionada.</div>
    );
  }

  return (
    <>
      <div
        ref={cursoCompradoVideoRef} // Attach the reference
        className="curso-comprado-video" // Clase para el contenedor padre
        onMouseLeave={() => {
          handleMouseLeave();
          setVIsHover(false);
        }}
        onMouseMove={handleMouseMovePantalla}
      >
        {vIsPrimerPlay ? mInfoVideo() : null}
        {vIsPrimerPlay ? mPlayGrande() : null}

        {mControls()}
        {isLoading && ( // Muestra el spinner si el video está cargando
          <div className="video-loading-spinner">
            <ThreeCircles
              visible={true}
              color="#fff"
              ariaLabel="three-circles-loading"
              wrapperStyle={{}}
              wrapperClass="icono-play"
            />
          </div>
        )}
        <>
          <video
            id="video-leccion"
            ref={videoRef}
            className="video-contenedor" // Clase para el video
            onTimeUpdate={handleTimeUpdate}
            onLoadedMetadata={handleLoadedMetadata}
            onWaiting={handleLoading} // Activa el estado de carga
            onCanPlay={handleCanPlay} // Desactiva el estado de carga
            onError={handlePlaybackError} // Maneja errores de reproducción
            onEnded={() => {
              if (isFullscreen) {
                toggleFullscreen(); // Salir de pantalla completa al finalizar el video
              }
              setVIsVideoTerminado(true);
              setVIsPrimerPlay(true);
              mEnviarProgresoVideo(true);
              handlePlayPause();
              actualizarLeccion(true);
            }}
            onLoadStart={() => {
              setIsLoading(true); // Activa el estado de carga
            }}
            onLoadedData={setResumeTime} // Llama al método setResumeTime
            controls={false}
            preload="auto" // Cambiado a "auto" para habilitar la descarga progresiva
          >
            <source
              src={`${V_URL_API}/api/video_leccion/${vLeccionId}`}
              type="video/mp4"
            />
            {/*
            {subtituloUrl && (
            <track
              label="Español"
              kind="subtitles"
              srcLang="es"
              src={subtituloUrl}
              default
            />
          )}
            */}
          </video>
          <Subtitulos
            vLeccion={vLeccion}
            videoRef={videoRef}
            vIsSubtitulos={vIsSubtitulos}
          />
        </>
      </div>
    </>
  );
}
